import { render, staticRenderFns } from "./message-tasks.vue?vue&type=template&id=18940f82&scoped=true&"
import script from "./message-tasks.vue?vue&type=script&lang=js&"
export * from "./message-tasks.vue?vue&type=script&lang=js&"
import style0 from "./message-tasks.vue?vue&type=style&index=0&id=18940f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18940f82",
  null
  
)

export default component.exports